module.exports = __webpack_public_path__ + "static/assets/95be8547447707daedc68ea89d7b9370.gif";